import { render, staticRenderFns } from "./PointsPage.vue?vue&type=template&id=af12b126"
import script from "./PointsPage.vue?vue&type=script&lang=js"
export * from "./PointsPage.vue?vue&type=script&lang=js"
import style0 from "./PointsPage.vue?vue&type=style&index=0&id=af12b126&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports